var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 509",
    width: 72,
    height: 72,
    rx: 36,
    fill: "#E5FBEE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 353",
    cx: 40.5,
    cy: 36,
    r: 15,
    fill: "#03C302"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 354",
    cx: 36.001,
    cy: 36.0014,
    r: 15,
    transform: "rotate(9.8144 36.001 36.0014)",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M30.75 36.75L33.75 39.75L41.25 32.25",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d2cdf5fed6451598599cb3d5e08d2d8e.svg";
export { ForwardRef as ReactComponent };